import type { PostEntryInput } from '@taler/api-client'
import { negateMoney, signOfMoney, type CurrencyCode, type LocalDate, type Money } from '@taler/domain'

export type PaybackDirection = 'THEY_PAID_ME' | 'I_PAID_THEM'

export interface PaybackEntryInput {
  readonly direction: PaybackDirection
  readonly moneyAccountId: string
  readonly contactAccountId: string
  readonly amount: Money
  readonly date: LocalDate
  readonly memo: string
}

export function defaultPaybackDirection(
  balances: readonly Money[],
  currency?: CurrencyCode,
): PaybackDirection {
  const balance = balances.find((candidate) => candidate.currency === currency)
  return balance !== undefined && signOfMoney(balance) < 0 ? 'I_PAID_THEM' : 'THEY_PAID_ME'
}

export function toPaybackEntry(input: PaybackEntryInput): PostEntryInput {
  if (signOfMoney(input.amount) <= 0) throw new Error('A repayment amount must be positive')
  const contactAmount = input.direction === 'THEY_PAID_ME' ? negateMoney(input.amount) : input.amount
  const moneyAmount = input.direction === 'THEY_PAID_ME' ? input.amount : negateMoney(input.amount)
  return {
    date: input.date,
    memo: input.memo.trim(),
    postings: [
      { accountId: input.moneyAccountId, amount: moneyAmount },
      { accountId: input.contactAccountId, amount: contactAmount },
    ],
  }
}
